@if (section(); as s) {
  <app-section-wrapper [id]="s.id" [title]="s.title" [background]="s.background">
    <p class="solution-intro">{{ s.intro }}</p>

    <div class="solution-grid stagger">
      @for (item of s.items; track item.title) {
        <div class="solution-card">
          <div class="solution-card__icon">
            <mat-icon>{{ item.icon }}</mat-icon>
          </div>
          <h3 class="solution-card__title">{{ item.title }}</h3>
          <p class="solution-card__desc">{{ item.description }}</p>
          @if (item.demoHref && item.demoLabel) {
            <a
              [href]="item.demoHref"
              target="_blank"
              rel="noopener"
              mat-stroked-button
              class="solution-card__link"
            >
              {{ item.demoLabel }}
              <mat-icon iconPositionEnd>open_in_new</mat-icon>
            </a>
          }
        </div>
      }
    </div>
  </app-section-wrapper>
}
